import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { AuthenticationService } from './authentication.service'
import {
  FeatureAccessService,
  RestaurantFeature,
} from './feature-access.service'

/**
 * Lets a page open only for a restaurant that has the feature, so one hidden from the
 * menu cannot be reached by its address either. Anyone else goes to the customers.
 */
export const restaurantFeatureGuard =
  (feature: RestaurantFeature): CanActivateFn =>
  async () => {
    // Taken before anything is awaited, as inject() only works until then.
    const router = inject(Router)
    const auth = inject(AuthenticationService)
    const featureAccess = inject(FeatureAccessService)

    if (!(await auth.isAuthenticated())) {
      return router.createUrlTree(['/login'])
    }
    return (await featureAccess.hasFeature(feature))
      ? true
      : router.createUrlTree(['/customers'])
  }
